import { API_AUTOMATION } from "@/services/XCONS_ENV";
import { axiosInstance } from "@/utilities";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

interface EmbedData {
  jwtToken: string;
  containerId: string;
  embedUrl: string;
}

type Props = {
  identifier?: string;
};

const ActivepiecesEmbed: React.FC<Props> = ({ identifier = "puntoseco" }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [embedData, setEmbedData] = useState<EmbedData | null>(null);
  const [error, setError] = useState<string | null>(null);

  const { id } = useParams();

  useEffect(() => {
    const fetchEmbedData = async () => {
      try {
        setError(null);
        const res = await axiosInstance.post(API_AUTOMATION, {
          identifier: id,
        });
        setEmbedData(res.data);
      } catch (e: any) {
        console.error("❌ Error cargando embed token:", e);
        setError(
          e?.response?.status ? `HTTP ${e.response.status}` : "Network/Error",
        );
      }
    };
    fetchEmbedData();
  }, [id]);

  useEffect(() => {
    if (!embedData) return;

    const allowedOrigin = new URL(embedData.embedUrl).origin;

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== allowedOrigin) return;

      const isRequestAuth =
        event.data === "REQUEST_AUTH" || event?.data?.type === "REQUEST_AUTH";

      if (isRequestAuth && iframeRef.current) {
        iframeRef.current.contentWindow?.postMessage(
          {
            type: "AUTH",
            token: embedData.jwtToken,
          },
          allowedOrigin,
        );
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [embedData]);

  if (error) return <p>Fallo al cargar el embed: {error}</p>;
  if (!embedData) return <p>Cargando...</p>;

  return (
    <iframe
      ref={iframeRef}
      src={`${embedData.embedUrl}/containers/${embedData.containerId}?embed=1`}
      style={{
        width: "100%",
        height: "90vh",
        border: "none",
        borderRadius: 12,
      }}
      allow="clipboard-write; clipboard-read; camera; microphone"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
    />
  );
};

export default ActivepiecesEmbed;
